import { Component, inject, input } from "@angular/core";
import { ChipsComponent } from "../../../shared/modules/chips/chips.component";
import { MatTooltip } from "@angular/material/tooltip";
import { TicketService } from "../services/ticket.service";
import { TranslatePipe } from "../../../shared/pipes/translate.pipe";

@Component({
  selector: "vl-record-buttons",
  standalone: true,
  imports: [ChipsComponent, MatTooltip, TranslatePipe],
  templateUrl: "./record-buttons.component.html",
  styleUrl: "./record-buttons.component.scss",
})
export class RecordButtonsComponent {
  ticketService = inject(TicketService);
  type = input<"icon" | "button">("icon");
}
